<template>
	<section>
		<nk-wrapper
			v-if="typeof context.links !== 'undefined' && context.links.length > 0"
			spacing="md"
		>
			<nk-accordion
				v-slot="{titleId}"
				:title="context.titel || 'Links'"
				title-size="xl"
				:open="options.openAccordion || false"
			>
				<nk-nav
					:aria-labelledby="titleId"
					variant="resources"
					prepend-icon="link"
					append-icon="arrow-right"
				>
					<nk-nav-item
						v-for="(link, index) in context.links"
						:key="`link-${index}`"
						:link="link.link"
						:title="link.linktext"
						:text="link.link"
						:target="!link.isintern ? '_blank' : null"
					/>
				</nk-nav>
			</nk-accordion>
		</nk-wrapper>
	</section>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {array} context.links
 * @prop {boolean} options.openAccordion
 */
export default {
	name: 'NkTemplateLinks',

	mixins: [TemplatesDefault],
};
</script>
